import { render, staticRenderFns } from "./iam-view-page.vue?vue&type=template&id=47cde330&scoped=true&"
import script from "./iam-view-page.vue?vue&type=script&lang=js&"
export * from "./iam-view-page.vue?vue&type=script&lang=js&"
import style0 from "./iam-view-page.vue?vue&type=style&index=0&id=47cde330&lang=scss&scoped=true&"
import style1 from "./iam-view-page.vue?vue&type=style&index=1&id=47cde330&lang=scss&scoped=true&"
import style2 from "./iam-view-page.vue?vue&type=style&index=2&id=47cde330&lang=scss&scoped=true&"
import style3 from "./iam-view-page.vue?vue&type=style&index=3&id=47cde330&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cde330",
  null
  
)

export default component.exports
import {QBreadcrumbs,QIcon,QBreadcrumbsEl,QCard,QInnerLoading,QSpinnerIos,QItemSection,QAvatar,QImg,QItemLabel} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QIcon,QBreadcrumbsEl,QCard,QInnerLoading,QSpinnerIos,QItemSection,QAvatar,QImg,QItemLabel})
